export default __webpack_public_path__ + "static/media/vtusd.5b4a0ae7.png";